import { render } from "./TileUnit.vue?vue&type=template&id=b839805c&scoped=true"
import script from "./TileUnit.vue?vue&type=script&lang=js"
export * from "./TileUnit.vue?vue&type=script&lang=js"

import "./TileUnit.vue?vue&type=style&index=0&id=b839805c&scoped=true&lang=css"

import exportComponent from "F:\\Users\\Sahar\\Desktop\\Super Tactico - Official App\\Online - Routed\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b839805c"]])

export default __exports__